import styled from "styled-components";

export const TrailSectionLoadingSkeletonContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(310px, calc(330px * 2)) minmax(0px, 1fr);
  gap: 3rem;
  align-items: center;
  padding: 80px 0;

  @media (max-width: 1280px) {
    padding: 40px 0;
  }

  @media (max-width: 1336px) {
    grid-template-columns: minmax(310px, calc(242px * 2)) minmax(0px, 1fr);
  }

  @media (max-width: 800px) {
    grid-template-columns: 1fr;
  }

  > div {
    padding-left: 3.125rem;

    @media (max-width: 800px) {
      display: flex;
      flex-direction: column;
      align-items: center;

      max-width: 100vw;
      padding-left: 3.125rem;
    }

    @media (max-width: 600px) {
      padding-left: 1.875rem;
    }
  }

  ul {
    display: flex;
    gap: 12px;

    margin-top: 1rem;
    margin-bottom: 0;

    @media (max-width: 800px) {
      max-width: 100vw;
      padding-left: 3.125rem;
    }

    li {
      list-style: none;
    }
  }
`;
